import React, { useEffect, useState } from 'react';
import { Modal, Input, InputNumber } from 'antd';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function EnrichmentNewFeedCollectionSaveModal({
  nameOfNewFeedCollection,
  vendorOfNewFeedCollection,
  setIsNewFeedCollectionModalVisible,
  isNewFeedCollectionModalVisible,
  handleSave,
  setCustomScoreOfNewFeedCollection,
  setNameOfNewFeedCollection,
  setVendorOfNewFeedCollection,
  typeOfContainer,
  iocType,
}) {
  const capitalize = (s) => s?.[0]?.toUpperCase() + s?.substring(1);
  const iocTypeMap = {
    ip: 'IP',
    ipv4: 'IP',
    domain: 'domain',
    url: 'URL',
  };

  return (
    <Modal
      bodyStyle={{ minHeight: 236, padding: 24 }}
      title={'Save to new ' + typeOfContainer}
      okButtonProps={{
        disabled:
          !nameOfNewFeedCollection ||
          nameOfNewFeedCollection?.trim()?.length === 0,
      }}
      open={isNewFeedCollectionModalVisible}
      onOk={() => {
        handleSave();
        incrementUIRequestsCounter();
      }}
      onCancel={() => setIsNewFeedCollectionModalVisible(false)}
      okText="Save"
    >
      <h3
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        Create new {typeOfContainer} for {iocTypeMap?.[iocType]}
      </h3>
      <div>
        <span
          style={{
            fontWeight: 400,
            fontSize: 14,
            marginBottom: 4,
            display: 'block',
            color: 'rgba(255, 255, 255, 0.95)',
            marginLeft: 8,
          }}
        >
          {capitalize(typeOfContainer)} name (required)
        </span>
        <Input
          style={{ width: '100%' }}
          placeholder={`Enter ${typeOfContainer} name`}
          onChange={(event) => setNameOfNewFeedCollection(event.target.value)}
        ></Input>
      </div>
      <div style={{ marginTop: 24 }}>
        <span
          style={{
            fontWeight: 400,
            fontSize: 14,
            marginBottom: 4,
            display: 'block',
            color: 'rgba(255, 255, 255, 0.95)',
            marginLeft: 8,
          }}
        >
          {capitalize(typeOfContainer)} vendor
        </span>
        <Input
          style={{ width: '100%' }}
          placeholder="Enter vendor name"
          onChange={(event) => setVendorOfNewFeedCollection(event.target.value)}
        ></Input>
      </div>
      <div style={{ marginTop: 24 }}>
        <span
          style={{
            fontWeight: 400,
            fontSize: 14,
            marginBottom: 4,
            display: 'block',
            color: 'rgba(255, 255, 255, 0.95)',
            marginLeft: 8,
          }}
        >
          Source score
        </span>
        <InputNumber
          style={{ width: '100%' }}
          placeholder="Enter score"
          onChange={setCustomScoreOfNewFeedCollection}
        ></InputNumber>
      </div>
    </Modal>
  );
}

export default EnrichmentNewFeedCollectionSaveModal;
